// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { GetWishListLinesApiParameter } from "@insite/client-framework/Services/WishListService";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import {
    QuoteModel,
    WishListLineCollectionModel,
    WishListLineModel,
    WishListModel,
} from "@insite/client-framework/Types/ApiModels";
import { Draft } from "immer";

export type QuoteDetailsState = {
    quote: QuoteModel | null;
};

export type xQuoteDetailsState = {
    xQuoteDetails: QuoteDetailsState;
};

const initialState: QuoteDetailsState = {
    quote: null,
};

const xQuoteDetails = createTypedReducerWithImmer(initialState, {
    "Data/Quotes/CompleteLoadQuote": (draft: Draft<QuoteDetailsState>, actions: { quote: QuoteModel }) => {
        if (actions.quote) {
            draft.quote = actions.quote;
        }
    },
    "Data/Quotes/ClearQuote": (draft: Draft<QuoteDetailsState>) => {
        draft.quote = null;
    },
});

(reducers as any).xQuoteDetails = xQuoteDetails;

type xQuoteDetailsRecuder = {
    quoteDetails: typeof xQuoteDetails;
};

export type xQuoteDetailsActions = Parameters<xQuoteDetailsRecuder[keyof xQuoteDetailsRecuder]>[1] | AnyAction;
